/** Supabase auth error messages → Russian translations */
export const AUTH_ERRORS: Record<string, string> = {
  "Invalid login credentials": "Неверный email или пароль",
  "Email not confirmed": "Email не подтверждён",
  "User already registered": "Этот email уже зарегистрирован",
  "Password should be at least 6 characters": "Пароль должен быть не менее 6 символов",
  "Unable to validate email address: invalid format": "Некорректный формат email",
  "Signup requires a valid password": "Введите пароль",
  "Failed to fetch": "Ошибка подключения. Проверьте интернет и попробуйте снова.",
  "For security purposes, you can only request this after": "Слишком много попыток. Подождите немного и попробуйте снова.",
};

export function translateAuthError(message: string): string {
  for (const [key, value] of Object.entries(AUTH_ERRORS)) {
    if (message.includes(key)) return value;
  }
  return message;
}
